import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'RoundUpPipe'
})
export class RoundUpPipe implements PipeTransform {
  transform(value: number | string): number | string {
    if (typeof value === 'string') {
      return value;
    }

    if (!value && value !== 0) {
      return null;
    }

    // Округление до двух знаков после запятой
    const roundedValue = Math.ceil(value * 100) / 100;

    // Преобразование в число, чтобы убрать .00
    return parseFloat(roundedValue.toFixed(2));
  }
}
